import { render, staticRenderFns } from "./CompGoFlexRequestsTableDesk.vue?vue&type=template&id=423fe5ca&scoped=true"
import script from "./CompGoFlexRequestsTableDesk.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGoFlexRequestsTableDesk.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGoFlexRequestsTableDesk.vue?vue&type=style&index=0&id=423fe5ca&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423fe5ca",
  null
  
)

export default component.exports